import i18n from '@/locale/i18n'

import paymentRule from '@/page/paymentRule/index'
import paymentRule2 from '@/page/paymentRule/index2'
export default [
	{
		path: '/paymentRule',
		component: paymentRule,
		meta: { title: i18n.t('paymentRule.title') }
	},
	{
		path: '/paymentRule2',
		component: paymentRule2,
		meta: { title: i18n.t('paymentRule.title2') }
	},
]



// WEBPACK FOOTER //
// ./src/router/paymentRule/index.js